// TODO: Dedupe.
export function encodeMessage(message) {
    return new Uint8Array(Buffer.from(message));
}
// TODO: Dedupe.
export function decodeMessage(encodedMessage, display) {
    if (display === 'utf8') {
        return Buffer.from(encodedMessage).toString();
    }
    if (display === 'hex') {
        return `0x${Buffer.from(encodedMessage).toString('hex')}`;
    }
    throw new Error(`Unknown display: '${display}'`);
}
export function serializeEncodedMessage(encodedMessage) {
    return Buffer.from(encodedMessage).toString('base64');
}
export function deserializeEncodedMessage(wireEncodedMessage) {
    return Buffer.from(wireEncodedMessage, 'base64');
}
